<template>
  <h2 class="text-with-line-center" v-if="text"><span>{{text}}</span></h2>
</template>

<script>
  export default {
    name: 'appTextLinedCenter',
    props: {
      text: {
        type: String,
        default: 'default some text'
      }
    }
  }
</script>

<style lang="scss">
  .text-with-line-center {
    position: relative;
    display: flex;
    align-items: center;
    margin: 20px 0;
    user-select: none;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 1px;
      background: #D4DCE5;
    }

    & span {
      position: relative;
      margin: 0 auto;
      padding: 0 16px;
      font-size: 14px;
      font-weight: 400;
      color: #5D607B;
      background: #ffffff;
    }
  }
  .text-with-line_blue-bg {

    &:before {
      background: rgba(0, 82, 127, .4);
    }
    & span {
      color: $darkBlue;
      background: #EFF3F6;
    }
  }
</style>
